import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-individual-pupil-list',
    templateUrl: './individual-pupil-list.component.html',
    styleUrls: ['./individual-pupil-list.component.scss']
})
export class IndividualPupilListComponent {
    @Input() pupil;
    @Input() currentPupil;
    @Input() index;
    @Input() isAbsent;

    constructor() {}
}
